import type { Ref } from 'vue'

import type { PublicFooterMenu } from '@/service/__generated-api'

type FooterSettings = Pick<
  PublicFooterMenu,
  'contact_text' | 'items' | 'footer_newsletter_enabled'
>

// Ref.: https://v3.nuxtjs.org/guide/features/state-management/
export const useFooterSettings = async (): Promise<
  Ref<FooterSettings | null>
> => {
  const settings = useState<FooterSettings | null>(
    'footer-settings',
    () => null
  )

  if (!settings.value) {
    settings.value = await useApi().publicMenuFooterRetrieve({
      fetchKeys: {
        items: true,
        contact_text: true,
        footer_newsletter_enabled: true
      }
    })
  }

  return settings
}
